import { SearchField } from './SearchField';
import { usePlaceNavigation } from '../hooks/usePlaceNavigation';

/**
 * Search pill floating over the map, wired to pan/zoom the map.
 */
export function MapSearchBar({ className }: { className?: string }) {
  const { handlePlaceSelect, handleCurrentLocation, isFetchingLocation } =
    usePlaceNavigation();

  return (
    <SearchField
      onPlaceSelect={handlePlaceSelect}
      onCurrentLocation={handleCurrentLocation}
      isLoadingLocation={isFetchingLocation}
      className={className}
    />
  );
}
